// src/PublicUser/components/BlogCard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

const BlogCard = ({ blog, index }) => {

const navigate = useNavigate();

  const handleReadMore = (e) => {
    e.stopPropagation(); // Prevents triggering the card click if you have one
    navigate(`/blog/${blog.id}`);
  };

  const handleCardClick = () => {
    navigate(`/blog/${blog.id}`);
  };

  return (
    <article className="ts-blog-card" style={{ animationDelay: `${index * 0.05}s` }}>
      <div className="ts-card-image-wrapper">
        <img src={blog.coverImageUrl} alt={blog.title} className="ts-card-image" />
        <div className="ts-card-overlay">
        <button 
            className="ts-read-more-btn"
            onClick={handleReadMore}
          >
            Read Article →
          </button>
        </div>
        <div className="ts-card-category">{blog.category}</div>
      </div>
      
      <div className="ts-card-content">
        <div className="ts-card-meta">
          <div className="ts-meta-author">
            <img src={blog.authorAvatar} alt={blog.author} className="ts-author-avatar" />
            <span>{blog.author}</span>
          </div>
          <div className="ts-meta-date">
            📅 {new Date(blog.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
          </div>
          <div className="ts-meta-read">⏱️ {blog.readTime}</div>
        </div>
        
        <h3 className="ts-card-title">{blog.title}</h3>
        <p className="ts-card-description">
          {blog.description?.trim().slice(0, 100)}
          {blog.description?.length > 100 && "..."}
        </p>
        
        {/* <div className="ts-card-footer">
          <div className="ts-card-stats">
            <span>👍 124 likes</span>
            <span>💬 8 comments</span>
          </div>
        </div> */}
      </div>
    </article>
  );
};

export default BlogCard;